import React from "react";
import { ITransformedColumn } from "../../zComponents/CustomizedMetaCard/CustomizedMetaCard.d";
import { MultiStyleCardConfig } from "../../zComponents/CustomizedMetaCard/CustomizedMetaCard";
import ZFIcon from "../ZFIcon/ZFIcon";
import { Tooltip } from "../tooltip/Tooltip";
import { METRIC_DEFINITION_MAP_CONFIG } from "../../../config/metric-definition";

const ZFMultiStyleCard: React.FC<IMultiStyleCardProps> = ({
	config: { globalConfig, multiStyleCardConfig },
}: IMultiStyleCardProps) => {
	return (
		<div className="multi-style-card">
			{globalConfig && globalConfig.length > 0 && (
				<div className="global-data-row">
					{globalConfig.map((g) => {
						return (
							<div className="global-data-column">
								{g.prefix && <span>{g.prefix} </span>}
								{<span>{g.value}</span>}
								{g.suffix && <span> {g.suffix}</span>}
							</div>
						);
					})}
				</div>
			)}
			{multiStyleCardConfig.map((row) => {
				return (
					<>
						<div className="header-row">
							{row.map((column) => {
								return (
									<div className="header">
										{column.headerLegend && (
											<div
												className="header-legend"
												style={{
													backgroundColor:
														column.headerLegend,
												}}
											></div>
										)}
										<Tooltip
											metricDefinition={METRIC_DEFINITION_MAP_CONFIG.get(
												column.toolTipKey
											)}
										>
											<span>{column.header}</span>
										</Tooltip>
									</div>
								);
							})}
						</div>
						<div className="row">
							{row.map((column) => {
								return (
									<div className="column">
										<div className="header-mobile">
											{column.headerLegend && (
												<div
													className="header-legend"
													style={{
														backgroundColor:
															column.headerLegend,
													}}
												></div>
											)}
											{column.header}
										</div>
										{column.value !== null &&
											column.value !== undefined && (
												<div className={column.thClass}>
													{getValObjectTemplate(
														column
													)}
												</div>
											)}
										{column.valueArray && (
											<div className="value-array">
												{column.valueArray.map(
													(valObject) => {
														return (
															<div>
																{getValObjectTemplate(
																	valObject
																)}
															</div>
														);
													}
												)}
											</div>
										)}
									</div>
								);
							})}
						</div>
					</>
				);
			})}
		</div>
	);
};

export default ZFMultiStyleCard;

interface IMultiStyleCardProps {
	config: MultiStyleCardConfig;
}

const getPrefixSuffixTemplate = (
	suffixObject: string | ITransformedColumn,
	className: string
) => {
	return (
		<div className={className}>
			{typeof suffixObject === "string" && <span>{suffixObject}</span>}
			{typeof suffixObject === "object" && (
				<div>
					{/* {(suffixObject.iconName) && <ZFIcon iconName={suffixObject.iconName} iconClasses={['zf-icon-react--size-s']}/>} */}
					{getValObjectTemplate(suffixObject as ITransformedColumn)}
				</div>
			)}
		</div>
	);
};

const getValObjectTemplate = (valObject: ITransformedColumn) => {
	return (
		<>
			<div
				className={"text-wrap" + " " + valObject.class}
				style={{ display: "inline-flex" }}
			>
				{valObject.icon && (
					<ZFIcon
						iconName={valObject.icon.name}
						iconClasses={valObject.icon.class.split(" ")}
					/>
				)}
				{valObject.prefix &&
					getPrefixSuffixTemplate(valObject.prefix, "zf-margin-r-m")}
				<span className={valObject.thClass}>{valObject.value}</span>
				{valObject.suffix &&
					getPrefixSuffixTemplate(valObject.suffix, "zf-margin-l-m")}
			</div>
		</>
	);
};
